import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCart = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4.505 2.25a.75.75 0 0 1 .75.607l.369 1.893h14.104a1.75 1.75 0 0 1 1.695 2.187l-1.678 6.5a1.75 1.75 0 0 1-1.694 1.313H7.568l.293 1.505q.078-.005.158-.005c1.259 0 2.32.846 2.647 2h3.707a2.751 2.751 0 0 1 5.396.75 2.75 2.75 0 0 1-5.396.75h-3.707a2.751 2.751 0 1 1-4.236-2.994L3.9 3.75H1.5a.75.75 0 0 1 0-1.5h3.005m2.771 11h10.775a.25.25 0 0 0 .242-.187l1.677-6.5a.25.25 0 0 0-.242-.313H5.915zm.743 4.5q-.251.002-.468.09a1.25 1.25 0 1 0 .468-.09m9 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCart;
